import React, { Component } from 'react';
import ConfiguratorSection from './../ConfiguratorSection';
import ConfiguratorImage from './../ConfiguratorImage';
import ConfiguratorOption from './../ConfiguratorOption';
import Disclaimer from '../Disclaimer';
import PdfForm from '../PdfForm';
import ShareFrom from '../ShareForm';
import TransomConfigurator from './../TransomConfigurator';
import { withTranslation, Trans } from 'react-i18next';
import { exterior_view01ImageOptions } from './views/exterior_view01'

class XC38Summary extends Component {
    constructor(props) {
        super(props);

        this.state = {
            expanded: false
        };
    }

    render() {
        let imageOptions = exterior_view01ImageOptions;

        let image = (
            <TransomConfigurator colorMultiplier={0.75} name={this.props.configuration.transom.Name} port={this.props.configuration.transom.Port} transomSize={{ width: 1800, height: 785 }} transform={
                [
                    0.056576, -0.011704, 0, -0.000061,
                    0.011961, 0.097409, 0, 0.000008,
                    0, 0, 1, 0,
                    214, 320, 0, 1
                ]}>
                <ConfiguratorImage boat="XC38" configuration={this.props.configuration.exterior} options={imageOptions} />
            </TransomConfigurator>
        );



        return (
            <ConfiguratorSection image={image}>

                <ConfiguratorOption style={{position:'relative'}}>
                    <h1><Trans defaults='Summary' /></h1>
                    <h2><Trans defaults='Congratulations!' /></h2>
                    <p><Trans defaults='You have now configured the basics of an Xc 38. If you want a full configuration of your boat, please contact your local X-Yachts Dealer.' /></p>
                 

                    <PdfForm boat="xc38" country={this.props.country} countries={this.props.countries} configuration={this.props.configuration} code={this.props.code} />

                    <ShareFrom configuration={this.props.configuration} boat="xc38" code={this.props.code} />
                    
                    <Disclaimer />
                </ConfiguratorOption>
            </ConfiguratorSection>
        );
    }
}

export default withTranslation()(XC38Summary);


// WEBPACK FOOTER //
// ./src/XC38/XC38Summary.js